import * as React from 'react';

import classNames from 'classnames';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/ondemand';

import 'css!./__styles__/FeedbackPointsDisplay';

type Props = {
  points: number;
  actualPoints?: number;
  checked?: boolean;
};

/**
 * Displays the points for an option when you are receiving a review.
 * @param actualPoints - if this is the "checked" option, pass the actual points that the learner received so that we
 *   can cross out `points` and show their actual points in case `actualPoints` differs from `points`.
 * @param points - the points on the option.
 */
const FeedbackPointsDisplay = ({ points, actualPoints, checked }: Props) => {
  const actualPointsDiffers = actualPoints != null && actualPoints !== points;

  const pointsDisplayClass = classNames({
    'crossed-out-points': actualPointsDiffers,
  });

  return (
    <span className="rc-FeedbackPointsDisplay">
      <Typography2 component="span" variant={checked ? 'subtitleMedium' : 'bodyPrimary'} className={pointsDisplayClass}>
        <FormattedMessage message={_t('{points, plural, one{# point} other{# points}}')} points={points} />
      </Typography2>
      {actualPointsDiffers && (
        <Typography2 component="span" variant={checked ? 'subtitleMedium' : 'bodyPrimary'}>
          <FormattedMessage
            message={_t(' +{points, plural, one{# point} other{# points}} because of a tie')}
            points={actualPoints}
          />
        </Typography2>
      )}
    </span>
  );
};

export default FeedbackPointsDisplay;
